import { backendApi, Result } from "./backendApi";

export interface HybrideTypeModel {
  id: number;
  hybridType: String;
}

class GetHybridTypesRequest {}

class GetHybridTypesResponse {
  hybridTypes?: HybrideTypeModel[];
}

export const hybridTypeApi = {
  async getHybridTypes(): Promise<Result<HybrideTypeModel[]>> {
    let response =
      await backendApi.sendAndGetResponseAsync<GetHybridTypesResponse>(
        "GetHybridTypes",
        new GetHybridTypesRequest(),
      );

    if (response.ok) {
      return { ok: true, value: response.value.hybridTypes ?? [] };
    }

    return response;
  },
};
